import { render } from "./ButtonRow.vue?vue&type=template&id=1a6c1519&scoped=true"
import script from "./ButtonRow.vue?vue&type=script&lang=js"
export * from "./ButtonRow.vue?vue&type=script&lang=js"

import "./ButtonRow.vue?vue&type=style&index=0&id=1a6c1519&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c1519"]])

export default __exports__